__webpack_require__.p = "/dark-mode-adyen-drop-in/referrals-hub/";